import { useContext } from 'react';
import AuthContext from '../../context/authProvider';

/**
 * Custom hook to get user permissions without importing AuthContext in every component
 * This provides a clean way to access permissions using our license helper system
 * 
 * @returns {Object} Object containing permissions and user info
 */
export const usePrivileges = () => {
    const { auth } = useContext(AuthContext);
    const { privileges } = auth?.user?.extra || {};
    // console.log('auth', auth);
    // console.log('usePrivileges', privileges);
    return {
        permissions:  privileges?.permissions || [],
        license_plan: privileges?.license_plan,
        roles: privileges?.roles || [],
        user: auth?.user,
        isAuthenticated: !!auth?.user,
        // New structured license data
        license_features: privileges?.license_features || [],
        module_access: privileges?.module_access || [],
        license_status: privileges?.license_status || null,
        // Add any other auth-related data you might need
    };
};

/**
 * Hook specifically for getting just permissions
 * 
 * @returns {Array} Permissions array
 */
export const usePermissionsOnly = () => {
    const { auth } = useContext(AuthContext);
    return auth?.user?.extra?.privileges?.permissions || [];
};

/**
 * Hook for getting user info
 * 
 * @returns {Object} User object
 */
export const useUser = () => {
    const { auth } = useContext(AuthContext);
    return auth?.user || null;
}; 